import React from 'react';
import FieldTrip112025 from 'views/FieldTrip112025';

const VissionAndMissionPage = () => {
  return <FieldTrip112025/>;
};

export default VissionAndMissionPage;